module.exports = __webpack_public_path__ + "static/forecast/weather/daycloud-ab17665d0729963016ea76ac5cf71891.svg";